import { createFileRoute, useParams } from "@tanstack/react-router";
import { EntityTypeFormTab } from "@/features/form-editor/components/entity-type-form-tab";

const ROUTE_ID =
	"/_authenticated/(admin-app)/_admin/admin/configuration/jobTypes/$jobTypeId/schema" as const;

export const Route = createFileRoute(ROUTE_ID)({
	component: AdminJobTypeSchemaTab,
});

function AdminJobTypeSchemaTab() {
	const { jobTypeId } = useParams({ from: ROUTE_ID });
	return <EntityTypeFormTab entity="job" typeId={jobTypeId} scope="admin" />;
}
